module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="l-layout ' +
((__t = ( this.is_b2c ? 'is-b2c' : '' )) == null ? '' : __t) +
'">\r\n    <div class="l-layout__header"></div>\r\n    <div class="l-layout__top-block"></div>\r\n    <div class="l-layout__main"></div>\r\n    <div class="l-layout__footer"></div>\r\n</div>\r\n';

}
return __p
}